export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_TRANSLATION_LOCALE || "sv-SE";
export const ENABLED_LOCALES = (process.env.REACT_APP_ENABLED_TRANSLATION_LOCALES || DEFAULT_LOCALE).split(",");
export const APPLICATION_LOCALE_KEY = "__APPLICATION_LOCALE_KEY__";

// Application locales without a translation file of their own read another locale's copy.
// en_SE is the English (EU) storefront on www.wallmek.se/en and shares the British English texts.
const TRANSLATION_LOCALE_ALIASES: Record<string, string> = {
    "en-SE": "en-GB",
};

// The i18n language (and locales/*.json file) that serves an application locale such as "en_SE".
export const translationLocaleFor = (applicationLocale?: string | null): string => {
    const dashed = (applicationLocale || DEFAULT_LOCALE).replace("_", "-");

    return TRANSLATION_LOCALE_ALIASES[dashed] || dashed;
};
